import { buildModelManager } from "../builder.js";
const DefaultPropertyAccessSelection = {
  __typename: true,
  id: true,
  accessLevel: true,
  createdAt: true,
  deletedAt: true,
  endDate: true,
  isActive: true,
  notes: true,
  parentAccessId: true,
  propertyId: true,
  revokedAt: true,
  rootPropertyAccessId: true,
  spendThreshold: true,
  startDate: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "propertyAccess";
const pluralModelApiIdentifier = "propertyAccesses";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPropertyAccessSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPropertyAccess",
    operationReturnType: "CreatePropertyAccess",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      propertyAccess: { required: false, type: "CreatePropertyAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePropertyAccesses",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePropertyAccessesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "updatePropertyAccess",
    operationReturnType: "UpdatePropertyAccess",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyAccess: { required: false, type: "UpdatePropertyAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePropertyAccesses",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePropertyAccessesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "restorePropertyAccess",
    operationReturnType: "RestorePropertyAccess",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyAccess: { required: false, type: "RestorePropertyAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "bulkRestorePropertyAccesses",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestorePropertyAccessesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "revokePropertyAccess",
    operationReturnType: "RevokePropertyAccess",
    functionName: "revoke",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyAccess: { required: false, type: "RevokePropertyAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "bulkRevokePropertyAccesses",
    functionName: "bulkRevoke",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "revoke",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRevokePropertyAccessesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "upsertPropertyAccess",
    operationReturnType: "UpsertPropertyAccess",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      propertyAccess: { required: false, type: "UpsertPropertyAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePropertyAccessResult": { hasReturnType: false },
      "... on UpdatePropertyAccessResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPropertyAccesses",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPropertyAccessesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPropertyAccessSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "propertyAccessGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PropertyAccessManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPropertyAccessSelection,
  operations
);
export {
  DefaultPropertyAccessSelection,
  PropertyAccessManager
};
//# sourceMappingURL=PropertyAccess.js.map
